import { render, staticRenderFns } from "./Zendesk.vue?vue&type=template&id=70b8c4c3&"
import script from "./Zendesk.vue?vue&type=script&lang=js&"
export * from "./Zendesk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports